var map = {
	"./chiron.png": "hil2",
	"./jupiter.png": "UqpA",
	"./mars.png": "l+qE",
	"./mean_node.png": "wl+V",
	"./mercury.png": "lsH7",
	"./moon.png": "B6vv",
	"./neptune.png": "YImY",
	"./pluto.png": "YZ6B",
	"./saturn.png": "iw/g",
	"./sun.png": "W25A",
	"./true_node.png": "mB/E",
	"./uranus.png": "cmxE",
	"./venus.png": "kqow"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aYxL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/planets ^\.\/.*\.png$
// module id = aYxL
// module chunks = 0